import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import EventGuestForm from './forms/EventGuestForm';
import {AppContext} from "../../../../../contexts/AppContext";
import useEventGuestService from "../../../../../app/services/intranet_company/hooks/useEventGuestService";
import {defaultEventGuest, EventGuest} from "../../../../../app/models/EventGuest";
import {ServiceResponse} from "../../../../../app/services/shared/interfaces";
import ButtonCancelForm from "../../../../../components/buttons/ButtonCancelForm";
import ButtonSaveForm from "../../../../../components/buttons/ButtonSaveForm";

interface Props {
    eventId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;

    
}

const EventGuestCreate = ({ eventId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { storeEventGuest,fetchingStoreEventGuest } = useEventGuestService();
    const [eventGuest, setEventGuest] = useState<EventGuest>({
        ...defaultEventGuest,
        event_id: eventId,
    });
    const [errorFields, setErrorFields] = useState<any>();

    const save = () => {
        if (showLoading) showLoading('loading', 'Guardando invitado...');
        storeEventGuest(eventGuest, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.success(response.message);
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            },
        });
    };
    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <EventGuestForm eventGuest={eventGuest} setEventGuest={setEventGuest} errorFields={errorFields} />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreEventGuest} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={save} locked={fetchingStoreEventGuest} />
                </div>
            </div>
        </>
    );
};

export default EventGuestCreate;
